import(/* webpackMode: "eager" */ "/home/runner/work/common-wealth-pwa/common-wealth-pwa/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/common-wealth-pwa/common-wealth-pwa/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/common-wealth-pwa/common-wealth-pwa/src/components/shared/back-button/BackButton.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/common-wealth-pwa/common-wealth-pwa/src/domain/funds/fund/projects/project/due-diligence/MarkdownSection/MarkdownSection.styles.css");
